declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCService } from '../../../../services/doc.service';
import { DownloadFileRequest } from '../../../../models/docs/doc.model';
import { ActorIdentitiesRequest, ActorDocRequest, ActorDocController, SaveCounsellingPlanRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, CounsellingPlanRequest, CounsellingPlanController, UpdateIvfCycleByActivityRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { DBOperation } from '../../../../enums/enum';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';

@Component({
  selector: 'updatecyclestatus',
  templateUrl: './updatecyclestatus.modal.html',
  styleUrls: ['./updatecyclestatus.modal.scss']
})

export class NgbUpdateCycleStatusModal implements OnInit {


  @Input() ActorDocCode;
  @Input() DownloadActorImageFileExtension: string;
  @Input() DownloadActorImageFile: string;
  @Input() FormattedCode: string;
  @Input() CanEdit: number;
    @Input() CanShow: number;
    @Input() TreatmentCycleCode: number;

  DOB: NgbDateStruct;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  StartDate: NgbDateStruct;
  EndDate: NgbDateStruct;
  RecommendedPackage: string;
  Doctor: string;
  PackageCost: number;
  SelectEmi: boolean;
   public FacilityName: string;
  Concerns: string;
  AddRemarks: string;
  file: File;
  fileList: FileList;



  FileExtension: string = "";
  MaritalStatus: string;
  JobType: string;
  public isRequesting: boolean = false;
  public ShowList: boolean = true;
  public isEdit: boolean = false;
  public ApiResData: ApiResponseModel;
  public ApiReqData: ApiRequestModel
  private modalRef: NgbModalRef;
  private isvisible = true;
  DocFriendlyName: string = "";
  

    CurrentUpdateIvfCycleByActivityRequest: UpdateIvfCycleByActivityRequest;
  CurrentEditCounsellingPalnRequest: SaveCounsellingPlanRequest;
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;
  CurrentActorDocController: ActorDocController[];

  @ViewChild('f') IdentitiesForm: NgForm;
  public UploadActorDoc: any;

  public CanDownLoadActorDoc: number

  public CanNurseView: number =0 ;

  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();
    
    //alert('Checking Forma ' + this.FormattedCode);
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";

    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPatientInfoByFormattedCodeController();
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

          ///this.LoadPatientCounsellingPlansIfAny();
         


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
 
  ActorCode: number;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private docservice: DOCService,
    private router: Router, private route: ActivatedRoute, private actorservice: ActorService, private tosterservice: NGXToastrService, private parserFormatter: NgbDateParserFormatter) { }
    ngOnInit() {
       // alert(this.FormattedCode);
    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
      this.LoadPatients();
      this.CurrentUpdateIvfCycleByActivityRequest = new UpdateIvfCycleByActivityRequest();
   
      this.CurrentUpdateIvfCycleByActivityRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.CurrentEditCounsellingPalnRequest = new SaveCounsellingPlanRequest();
    //this.CurrentEditCounsellingPalnRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentEditCounsellingPalnRequest = new SaveCounsellingPlanRequest();
    this.CurrentEditCounsellingPalnRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }



 
 
  
private stopRefreshing() {
  this.loaderService.displayLoader(false);
  this.isRequesting = false;
}
  private StartRefreshing() {
  this.loaderService.displayLoader(true);
  this.isRequesting = true;
  }
  
  edit(EditCounsellingplanController: CounsellingPlanController) {
    this.ShowList = false;
    this.isEdit = true;
    this.CurrentEditCounsellingPalnRequest.PlanStatus = EditCounsellingplanController.PlanStatus;
   
    this.CurrentEditCounsellingPalnRequest.TreatmentPlan = EditCounsellingplanController.TreatmentPlan;
    this.CurrentEditCounsellingPalnRequest.BranchCode = EditCounsellingplanController.BranchCode;
    this.CurrentEditCounsellingPalnRequest.StartDate = EditCounsellingplanController.StartDate;
    this.CurrentEditCounsellingPalnRequest.Concerns = EditCounsellingplanController.Concerns;
    this.CurrentEditCounsellingPalnRequest.CounsellingDoctor = EditCounsellingplanController.CounsellingDoctor;
    this.CurrentEditCounsellingPalnRequest.EndDate = EditCounsellingplanController.EndDate;
    this.CurrentEditCounsellingPalnRequest.FinancialStatus = EditCounsellingplanController.FinancialStatus;
    this.CurrentEditCounsellingPalnRequest.PackageCost = EditCounsellingplanController.PackageCost;
    this.CurrentEditCounsellingPalnRequest.CounsellingPlanCode = EditCounsellingplanController.CounsellingPlanCode;
    this.CurrentEditCounsellingPalnRequest.PlanStatus = EditCounsellingplanController.PlanStatus;
    this.CurrentEditCounsellingPalnRequest.Potential = EditCounsellingplanController.Potential;
    this.CurrentEditCounsellingPalnRequest.RecommendedPackage = EditCounsellingplanController.RecommendedPackage;
    this.CurrentEditCounsellingPalnRequest.Remarks = EditCounsellingplanController.Remarks;
    this.CurrentEditCounsellingPalnRequest.SelectEmi = EditCounsellingplanController.SelectEmi;
    this.CurrentEditCounsellingPalnRequest.ActorCode = EditCounsellingplanController.ActorCode.toString();
    //this.CurrentEditCounsellingPalnRequest.VisitCode = EditCounsellingplanController.VisitCode;
    this.FacilityName = EditCounsellingplanController.FacilityShortName;
    if (this.CurrentEditCounsellingPalnRequest.StartDate != null) {
      var SValidFrom = new Date(this.CurrentEditCounsellingPalnRequest.StartDate);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.StartDate >1990');
        this.StartDate = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }
    if (this.CurrentEditCounsellingPalnRequest.EndDate != null) {
      var SValidTo = new Date(this.CurrentEditCounsellingPalnRequest.EndDate);
      if (SValidTo.getFullYear() > 1900) {
        console.log('this.EndDate >1990');
        this.EndDate = {

          year: SValidTo.getFullYear(),
          month: SValidTo.getMonth() + 1,
          day: SValidTo.getDate()
        }
      }
    }
  }
  back() {
    this.ShowList = true;
    this.isEdit = false;
  }

  FacilityCode: number;
  //isvisiblebutton() {
    
  //  this.isvisible = false;
  //}
  onSubmit() {
    this.isvisible = false;

      this.CurrentUpdateIvfCycleByActivityRequest.TreatmentCycleCode = this.TreatmentCycleCode;
      this.CurrentUpdateIvfCycleByActivityRequest.ClosedByUser = AppData.Instance().UserLoginDetails.EmpFacilityCode;
      this.CurrentUpdateIvfCycleByActivityRequest.ClosedByUserName = AppData.Instance().UserLoginDetails.UserName;
      this.CurrentUpdateIvfCycleByActivityRequest.ActivityName = "ClosureCycle";
      this.CurrentUpdateIvfCycleByActivityRequest.ConditionalOperator = 10;
      this.CurrentUpdateIvfCycleByActivityRequest.ActivityApprovedActorCode = 0;
      this.CurrentUpdateIvfCycleByActivityRequest.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmpFacilityCode;
      this.CurrentUpdateIvfCycleByActivityRequest.ActivityDate = new Date();
      this.CurrentUpdateIvfCycleByActivityRequest.ActivityTime = new Date();
      this.CurrentUpdateIvfCycleByActivityRequest.DOC = 0;
      this.CurrentUpdateIvfCycleByActivityRequest.Dosage = "";
      this.CurrentUpdateIvfCycleByActivityRequest.MedicineCode = 0;
      this.CurrentUpdateIvfCycleByActivityRequest.MedicineName = "";
      this.CurrentUpdateIvfCycleByActivityRequest.TotalFolicularCount = 0;
      this.actorservice.UpdateIvfCycleByActivityV2(this.CurrentUpdateIvfCycleByActivityRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.isvisible = false;
            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  onEditSubmit() {
    
     this.isvisible = false;
    this.CurrentEditCounsellingPalnRequest.StartDate = new Date(this.parserFormatter.format(this.StartDate));
    this.CurrentEditCounsellingPalnRequest.EndDate = new Date(this.parserFormatter.format(this.EndDate));
    
    this.CurrentEditCounsellingPalnRequest.ConditionalOperator = 20;
    this.CurrentEditCounsellingPalnRequest.Remarks = "";
    this.CurrentEditCounsellingPalnRequest.CreatedUser = AppData.Instance().UserLoginDetails.DisplayName;
   
      
    this.CurrentEditCounsellingPalnRequest.VisitCode = "";


    this.actorservice.SaveCounsellingPlan(this.CurrentEditCounsellingPalnRequest)
        .subscribe((result) => {
          this.ApiResData = result;
          if (!this.ApiResData.hasError) {

            if (this.ApiResData.Result > 0) {
              //this.GetActorEducationInfoController();
              //this.GetResourceIdentificationByDateInfoController();
              // alertFunctions.AlertParam('Saved Successfully.....!');
              this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

              this.activeModal.close();

              this.stopRefreshing();
            }
            else {
              alertFunctions.AlertParam("Invalid Operation...!");


              this.stopRefreshing();

            }

          }
          else {
            this.stopRefreshing();
            if (this.ApiResData.ErrorData != "") {

              alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



            }
            else {
              this.stopRefreshing();
              alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

            }
          }

        },


          (error) => {

            if (error == "401 - Unauthorized") {
              alertFunctions.AlertParamEr(error);

              this.stopRefreshing();



            }
            else {
              alertFunctions.AlertParamEr(error);

              this.stopRefreshing();
            }
          }
        );

   
  }
  //PlansActive_Var: boolean = false;
  //NoPlansActive() {
  //  this.PlansActive_Var = false;
  //  if (this.CurrentCounsellingPlanController.length > 0) {
      
  //    var index = this.CurrentCounsellingPlanController.length;
  //    while (index > 0) {
  //      index--;
  //      if (this.CurrentCounsellingPlanController[index].PlanStatus == 'Completed' ||
  //        this.CurrentCounsellingPlanController[index].PlanStatus == 'Cancelled') {
  //        this.PlansActive_Var = false;
  //        break;

  //      }
  //    }
  //  }
  //  else {
  //    this.PlansActive_Var = true;
  //  }
   

  //}
}





  //GetActorDocController() {
  //  this.StartRefreshing();
  //  this.docservice.GetActorDocController(this.CurrentActorDocRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentActorDocController = this.ApiResData.Result;
  //        this.initGridButton();
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //    (error) => {

  //      if (error == "401 - Unauthorized") {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();



  //      }
  //      else {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();
  //      }
  //    }


  //    );

  //}

  

  /////////////////////////



  //

  // https://www.codeproject.com/Articles/1195569/Angular-Data-Grid-with-Sorting-Filtering-Export-to
  // dbops: DBOperation;
  //Grid Vars start














  /////////////////////////

